module.exports = __webpack_public_path__ + "static/livestreaming-2-7dd47c22b36512a364a6c5bb63b9c7f4.png";